var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadshotTipsAttire(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "181px",
    viewBox: "0 0 164 181",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 162.700927,
    height: 180.009536,
    rx: 15.2315762
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-21",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-23",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-25",
    points: "14.9998079 0 9.89792128 0 0 106.801023 14.9998079 125 30 106.801023 20.1020787 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4998817,0 L2.84438416,0 C0.732618192,0 -0.641354234,2.0849503 0.304017873,3.85686686 L0.304017873,3.85686686 L5.17796265,13 L10.4998817,13 L15.8225916,13 L20.696141,3.85686686 C21.6411177,2.0849503 20.2675407,0 18.1557747,0 L18.1557747,0 L10.4998817,0 Z",
    id: "path-49"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headshot-step-three-copy",
    transform: "translate(-638.000000, -328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(638.379139, 328.732119)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2C343E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7419916,208.150219 C127.972288,208.150219 167.881329,187.893688 167.881329,162.905991 C167.881329,144.447004 146.1025,128.569871 114.875689,121.533326 C103.831159,119.044589 91.6047363,117.661763 78.7419916,117.661763 C67.9643006,117.661763 57.6333558,118.632612 48.0701004,120.411409 C13.9503534,126.757796 -10.3973461,143.388699 -10.3973461,162.905991 C-10.3973461,187.893688 29.5116948,208.150219 78.7419916,208.150219 Z",
    id: "Combined-Shape",
    fill: "#AEAEAE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#C3C3C3",
    mask: "url(#mask-2)",
    cx: 80.8539735,
    cy: 56.5943651,
    rx: 39.6,
    ry: 43.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-96",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.620861, 105.267881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(17.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#F6FBF4",
    mask: "url(#mask-4)",
    points: "-3.71414117 21.2928411 -4.23593376 20.7689019 32.5519807 -16.1707378 33.0745418 -15.6467986"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#F6FBF4",
    mask: "url(#mask-6)",
    points: "-3.71414117 31.6823848 -4.23593376 31.1584457 32.5519807 -5.78157987 33.0745418 -5.2572549"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#F6FBF4",
    mask: "url(#mask-8)",
    points: "-3.71414117 42.0719286 -4.23593376 41.5479894 32.5519807 4.60796388 33.0745418 5.13228885"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#F6FBF4",
    mask: "url(#mask-10)",
    points: "-3.71414117 52.4614723 -4.23593376 51.9375332 32.5519807 14.9975076 33.0745418 15.5218326"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#F6FBF4",
    mask: "url(#mask-12)",
    points: "-3.71414117 62.8510161 -4.23593376 62.3266911 32.5519807 25.3870514 33.0745418 25.9113763"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#F6FBF4",
    mask: "url(#mask-14)",
    points: "-3.71414117 73.2405598 -4.23593376 72.7162349 32.5519807 35.7765951 33.0745418 36.3009201"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-41"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-82",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#F6FBF4",
    mask: "url(#mask-28)",
    points: "28.5615895 2.24852863 -9.29441511 -32.6015904 -8.75708316 -33.0958925 29.0989214 1.75422652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-51"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-50"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#F6FBF4",
    mask: "url(#mask-30)",
    points: "28.5615895 12.0503794 -9.29441511 -22.7997396 -8.75708316 -23.2940417 29.0989214 11.5560773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-54"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#F6FBF4",
    mask: "url(#mask-32)",
    points: "28.5615895 21.8522666 -9.29441511 -12.9978524 -8.75708316 -13.4925185 29.0989214 21.3579644"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-57"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#F6FBF4",
    mask: "url(#mask-34)",
    points: "28.5615895 31.6541173 -9.29441511 -3.19600168 -8.75708316 -3.69066779 29.0989214 31.1598152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-59"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#F6FBF4",
    mask: "url(#mask-36)",
    points: "28.5615895 41.4559681 -9.29441511 6.60584908 -8.75708316 6.11118298 29.0989214 40.961666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-63"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#F6FBF4",
    mask: "url(#mask-38)",
    points: "28.5615895 51.2578188 -9.29441511 16.4076998 -8.75708316 15.9130337 29.0989214 50.7635167"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-66"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#F6FBF4",
    mask: "url(#mask-40)",
    points: "28.5615895 61.0596696 -9.29441511 26.2095506 -8.75708316 25.7148845 29.0989214 60.5653675"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#F6FBF4",
    mask: "url(#mask-42)",
    points: "28.5615895 70.8615204 -9.29441511 36.0114014 -8.75708316 35.5167353 29.0989214 70.3668543"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#F6FBF4",
    mask: "url(#mask-44)",
    points: "28.5615895 80.6633711 -9.29441511 45.8132521 -8.75708316 45.318586 29.0989214 80.168705"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-75"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-81"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-50",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-80"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-95"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    fill: "#231F20",
    opacity: 0.290712629,
    points: "37.6083588 32.5372019 32.5002116 32.5372019 32.5002116 157 47.518426 138.879236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9489197,18.817244 L32.5002116,18.817244 L32.5002116,32.5370866 L37.6787603,32.5370866 L42.4210506,22.8877892 C43.340117,21.018089 42.0036429,18.817244 39.9489197,18.817244",
    id: "Fill-85",
    fill: "#231F20",
    opacity: 0.290712629
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    fill: "#D8D8D8",
    points: "65 15.2101093 57.9860114 0.0001152476 32.5002885 18.8173592 43.582175 35.2024947"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#EFEDED",
    points: "0 15.2101093 7.01437327 0.0001152476 32.5000962 18.8173592 21.417825 35.2024947"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    fill: "#B5B4B4",
    points: "32.5000962 18.817244 57.9858191 0 7.01437327 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-93",
    fill: "#9B9898",
    points: "32.5000962 18.817244 43.528893 10.6742327 21.471684 10.6742327"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadshotTipsAttire);
export default __webpack_public_path__ + "static/media/headshot-tips-attire.ce555bf6d4020b782186b4350afbe431.svg";
export { ForwardRef as ReactComponent };